import { ToastrService } from 'ngx-toastr';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Subscription } from 'rxjs';
import { ITypeAth } from '../../../interfaces/type-auth.interface';
import { AuthService } from '../../../services/auth-service/auth.service';
import { TranslateService } from '../../../services/translate/translate.service';
import { MangoEventAnalyticsService } from '../../../services/mango-events-analytics/mango-events-analytics.service';
import { DataLoginService } from '../../../services/dataLogin/data-login.service';
import { IConfigLogin } from '../../../interfaces/config-login.interface';

interface TranslateData {
  titleAuth: string;
  titleInstructions: string;
  textAuthCode: string;
  invalidCode: string;
  textTotp: string;
  textButtonTotp: string;
  buttonCancel: string;
  buttonCheck: string;
  instructionOne: string;
  instructionTwo: string;
  instructionTree: string;
  contentToast: string;
  titleToast: string;
  expire: string;
  textSms: string;
  instructionOneMobile: string;
  instructionTwoMobile: string;
  instructionTreeMobile: string;
  instructionFourMobile: string;
  instructionFiveMobile: string;
  instructionSixMobile: string;
}
@Component({
  selector: 'modal-auth',
  templateUrl: './modal-auth.component.html',
  styleUrls: ['./modal-auth.component.scss'],
})
export class ModalAuthComponent implements OnInit, OnChanges, OnDestroy {
  @Input() params: any = {};
  @Input() typeAuth: ITypeAth = {
    type: 'totp',
    statusModal: true,
    url: '',
    version: '0.0.0',
    route: '/dashboard',
  };
  @Output() statusModal = new EventEmitter<ITypeAth>();

  translate: TranslateData = {} as TranslateData;
  subscriptionTranslate!: Subscription;
  subscriptionToptp$!: Subscription;
  subscriptionSms$!: Subscription;
  statusTwoModal: boolean = false;
  validationCode: string = '';
  minutes: string = '00';
  seconds: string = '00';
  timeCode$!: any;
  sizeCheckSms: number = 4;
  nameTypeSms: string = 'sms';
  nameTypeTotp: string = 'totp';
  sizeCheckTotp: number = 6;
  isInvalidCode: boolean = false;
  activeCheck: boolean = false;
  code: string = '';
  qr: string = '';
  isLoading = false;
  dataLogin!: IConfigLogin;
  constructor(
    private authService: AuthService,
    private jwt: JwtHelperService,
    private router: Router,
    private translateService: TranslateService,
    private toastAlert: ToastrService,
    private mangoEventAnalyticsService: MangoEventAnalyticsService,
    private serviceDataLogin: DataLoginService
  ) {}

  ngOnInit(): void {
    this.dataTranslate();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.validationCode = '';
    this.activeCheck = false;
    this.dataLogin = this.serviceDataLogin.login();
    if (this.typeAuth.type === this.nameTypeTotp) {
      this.qr = this.typeAuth.totp?.qrCode || '';
      this.code = this.typeAuth.totp?.base32Secret || '';
    } else {
      const date = new Date(this.typeAuth.sms?.timeExp || '');
      this.validationCodeTime(date);
    }
  }
  onCodeChanged(e: any) {
    this.validationCode = e;
  }

  onCodeCompleted(e: any) {
    this.validationCode = e;
    this.activeCheck = false;
  }

  check() {
    this.activeCheck = true;
    this.isLoading = true;
    this.mangoEventAnalyticsService.sendEvent('two_factor_verify_attempt', {
      two_factor_type: this.typeAuth.type,
      user_pk: this.typeAuth.user?.pk || '',
      timestamp: new Date().toISOString(),
    });
    if (this.typeAuth.type === this.nameTypeSms) {
      this.authSms();
    } else {
      this.authTotop();
    }
  }

  authSms() {
    this.subscriptionSms$ = this.authService
      .verifySms(
        this.typeAuth.url,
        this.typeAuth.user?.pk || '',
        this.typeAuth.user?.sk || '',
        this.validationCode
      )
      .subscribe(
        (resp: any) => {
          this.isInvalidCode = false;
          this.authService.setToken(resp.jwtToken, resp?.refreshToken);
          const token = this.jwt.decodeToken(resp.jwtToken);
          const title = this.translate.titleToast;
          const content = `${this.translate.contentToast}, ${token.username}`;
          this.toastAlert.success(title, content);
          if (this.dataLogin.websocketUrl && this.params) {
            const authWsChannel = this.params?.authWsChannel || '';
            const wsUrl = this.dataLogin.websocketUrl;
            this.authService.emitDataWs(wsUrl, authWsChannel, {
              event: 'authenticated',
              data: {
                message: 'Authenticated successfully',
                accessToken: resp.jwtToken,
                refreshToken: resp.refreshToken,
                tokenType: 'Bearer',
                expiresIn: token.exp,
              },
            });
          }
          this.mangoEventAnalyticsService.sendEvent(
            'two_factor_verify_success',
            {
              two_factor_type: 'sms',
              username: token.username,
              timestamp: new Date().toISOString(),
            }
          );

          if (
            this.authService.getUrlRedirectLogin() &&
            this.authService.getUrlRedirectLogin().length > 0
          ) {
            this.router.navigateByUrl(this.authService.getUrlRedirectLogin());
          } else {
            let queryParams: any = {};
            if (this.params) {
              queryParams = this.params;
            }
            setTimeout(() => {
              this.router
                .navigate([`/${this.typeAuth.route}`], { queryParams })
                .then();
            }, 2000);
          }
          this.close();
        },
        (error) => {
          this.isInvalidCode = true;
          this.activeCheck = false;
          this.isLoading = false;
          this.mangoEventAnalyticsService.sendEvent('two_factor_verify_error', {
            two_factor_type: 'sms',
            user_pk: this.typeAuth.user?.pk || '',
            error: error.error?.message || 'Invalid code',
            timestamp: new Date().toISOString(),
          });
        }
      );
  }

  authTotop() {
    this.subscriptionToptp$ = this.authService
      .verifyTotp(
        this.typeAuth.url,
        this.typeAuth.user?.pk || '',
        this.typeAuth.user?.sk || '',
        this.validationCode,
        this.typeAuth.totp?.base32Secret || ''
      )
      .subscribe(
        (resp: any) => {
          this.isInvalidCode = false;
          this.authService.setToken(resp.jwtToken, resp?.refreshToken);
          const token = this.jwt.decodeToken(resp.jwtToken);
          const title = this.translate.titleToast;
          const content = `${this.translate.contentToast}, ${token.username}`;
          this.toastAlert.success(title, content);
          if (this.dataLogin.websocketUrl && this.params) {
            const authWsChannel = this.params?.authWsChannel || '';
            const wsUrl = this.dataLogin.websocketUrl;
            this.authService.emitDataWs(wsUrl, authWsChannel, {
              event: 'authenticated',
              data: {
                message: 'Authenticated successfully',
                accessToken: resp.jwtToken,
                refreshToken: resp.refreshToken,
                tokenType: 'Bearer',
                expiresIn: token.exp,
              },
            });
          }
          this.mangoEventAnalyticsService.sendEvent(
            'two_factor_verify_success',
            {
              two_factor_type: 'totp',
              username: token.username,
              timestamp: new Date().toISOString(),
            }
          );

          if (
            this.authService.getUrlRedirectLogin() &&
            this.authService.getUrlRedirectLogin().length > 0
          ) {
            this.router.navigateByUrl(this.authService.getUrlRedirectLogin());
          } else {
            let queryParams: any = {};
            if (this.params) {
              queryParams = this.params;
            }
            setTimeout(() => {
              this.router
                .navigate([`/${this.typeAuth.route}`], { queryParams })
                .then();
            }, 2000);
          }
          this.close();
        },
        (error) => {
          this.isInvalidCode = true;
          this.activeCheck = false;
          this.isLoading = false;
          this.mangoEventAnalyticsService.sendEvent('two_factor_verify_error', {
            two_factor_type: 'totp',
            user_pk: this.typeAuth.user?.pk || '',
            error: error.error?.message || 'Invalid code',
            timestamp: new Date().toISOString(),
          });
        }
      );
  }

  close() {
    const { statusModal, ...auth } = this.typeAuth;
    this.typeAuth = {
      ...auth,
      statusModal: false,
    };
    this.mangoEventAnalyticsService.sendEvent('two_factor_modal_close', {
      two_factor_type: this.typeAuth.type,
      timestamp: new Date().toISOString(),
    });
    this.statusModal.emit(this.typeAuth);
  }

  viewTwoModal() {
    this.statusTwoModal = !this.statusTwoModal;
  }

  validationCodeTime(date = new Date()) {
    const currentDate: Date = new Date();
    const timeDate = date.getTime() - currentDate.getTime();
    date = new Date(timeDate);
    this.timeCode$ = setInterval(() => {
      if (timeDate > 0) {
        this.minutes = this.padLeft(date.getMinutes() + '');
        this.seconds = this.padLeft(date.getSeconds() + '');
        date = new Date(date.getTime() - 1000);
      }
      if (this.minutes == '00' && this.seconds == '00') {
        clearInterval(this.timeCode$);
      }
    }, 1000);
  }

  padLeft(time: string) {
    return '00'.substring(0, '00'.length - time.length) + time;
  }

  dataTranslate() {
    this.subscriptionTranslate = this.translateService
      .init('core')
      .subscribe((data) => {
        this.translate = data.login.modalAuth;
      });
  }

  ngOnDestroy(): void {
    this.subscriptionSms$?.unsubscribe();
    this.subscriptionToptp$?.unsubscribe();
    this.subscriptionTranslate?.unsubscribe();
  }
}
